// IE 2026 10 13 / ODOO-5800: строки, которые не считаются alert-строками для заливки потомков (грид AttrGrid)
export const ALERT_PLAIN_MEASURES = ['IN_moq_topup']   // раздел «Добір до MOQ»: alert остаётся в значении (фильтры), заливки нет
export const ALERT_PLAIN_CLASS = 'alert-plain'          // запись может отключить заливку любого раздела классом conditional_format

// classes — массивы классов строки (_DLRow.cssClasses, cf_compute().cssClasses)
export function alertPlainRow(dataItem, classes) {
    if (!dataItem) return false
    if (ALERT_PLAIN_MEASURES.includes(String(dataItem.measure ?? ''))) return true
    for (const a of classes || []) {
        if (Array.isArray(a) && a.some(x => String(x || '').trim() === ALERT_PLAIN_CLASS)) return true
    }
    return false
}

export function alertIsRow(dataItem, { plainOn = true, classes = null } = {}) {
    if (!dataItem) return false
    if (plainOn && alertPlainRow(dataItem, typeof classes === 'function' ? classes() : classes)) return false
    if (String(dataItem.alert ?? '').trim()) return true
    return /_uncovered$/i.test(String(dataItem.measure ?? ''))
}
